import { isProduction } from '@zageno/config';
import datadogLogs from './datadog';
import Logger from './logger';
import { DatadogTransport, ConsoleTransport } from './transports';

const logger = new Logger();

logger.addTransport(new DatadogTransport(datadogLogs));
const p = isProduction();

if (!p) {
  logger.addTransport(new ConsoleTransport());
}

export default logger;

export { datadogLogs, Logger };
